import React, { useEffect, useState } from "react";
import SkeletonTable from "../../../components/table/SkeletonTable.jsx";
import columns from "../../../columns/clients/clientOrganizerDoc.js";
import { Spin } from "antd";
import {
  GetOrganizerAnswerApi,
  ReviewAnswerApi,
} from "../../../api/request/taskManager/taskManager.js";
import { useParams } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";
import toast from "react-hot-toast";
import ViewFilesModal from "../../reviewDoc/components/ViewFilesModal.jsx";

export default function OrganizerDoc() {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [selectedQuestion, setSelectedQuestion] = useState({});
  const [isFilesOpen, setIsFilesOpen] = useState(false);
  const getQuestions = async () => {
    try {
      setIsLoading(true);
      let params = { organizer_id: id };
      const { data } = await GetOrganizerAnswerApi(params);
      if (data?.status) {
        setData(
          data?.data?.map((section) => {
            return {
              ...section,
              questions: section?.questions?.map((question) => {
                return {
                  ...question,
                  response_text: (
                    <div className="flex items-center gap-3 max-w-[250px]">
                      <p className="text-wrap">
                        {question?.response_text || "--"}
                      </p>
                    </div>
                  ),
                  ...(question?.documents?.length && {
                    response_text: (
                      <button
                        type="button"
                        onClick={() => {
                          setSelectedQuestion(question);
                          setIsFilesOpen(true);
                        }}
                        className="hover:text-primary text-primary underline underline-offset-4 bg-transparent border-0 p-0 cursor-pointer text-left font-inherit"
                      >
                        View Files🔻
                      </button>
                    ),
                  }),
                  question: (
                    <div
                      className={`${
                        !question?.reviewed_checked
                          ? "font-semibold highlight-text"
                          : ""
                      }`}
                    >
                      {question?.field_label || "--"}
                    </div>
                  ),
                  review: (
                    <div
                      className="cursor-pointer"
                      onClick={() =>
                        reviewHandler(
                          section?.id,
                          question?.id,
                          question?.reviewed_checked
                        )
                      }
                    >
                      <img
                        className="size-7"
                        src={
                          question?.reviewed_checked
                            ? "/assets/icons/outlined-check-circle.svg"
                            : "/assets/icons/outlined-circle.svg"
                        }
                        alt="review status"
                      />
                    </div>
                  ),
                };
              }),
            };
          })
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getQuestions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const spinner = (
    <div className="my-[3px]">
      <Spin indicator={<LoadingOutlined />} />
    </div>
  );

  const setReviewData = (sectionId, questionId, status, isLoading) => {
    setData((prev) => {
      return prev.map((section) => {
        if (section.id === sectionId) {
          return {
            ...section,
            questions: section?.questions?.map((question) => {
              if (question.id === questionId) {
                return {
                  ...question,
                  reviewed_checked: status,
                  question: (
                    <div
                      className={`${
                        !status ? "font-semibold highlight-text" : ""
                      }`}
                    >
                      {question?.field_label || "--"}
                    </div>
                  ),
                  review: isLoading ? (
                    spinner
                  ) : (
                    <div
                      className="cursor-pointer"
                      onClick={() =>
                        reviewHandler(sectionId, questionId, status)
                      }
                    >
                      <img
                        className="size-7"
                        src={
                          status
                            ? "/assets/icons/outlined-check-circle.svg"
                            : "/assets/icons/outlined-circle.svg"
                        }
                        alt="review status"
                      />
                    </div>
                  ),
                };
              }
              return question;
            }),
          };
        }
        return section;
      });
    });
  };

  const reviewHandler = async (sectionId, questionId, status) => {
    try {
      setReviewData(sectionId, questionId, !status, true);

      let params = {
        id: questionId,
        reviewed_checked: !status,
      };
      const { data } = await ReviewAnswerApi(params);
      if (data?.status) setReviewData(sectionId, questionId, !status, false);
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
      setReviewData(sectionId, questionId, status, false);
    }
  };

  return (
    <div className="mb-6">
      <div className="border-2 rounded-xl p-5">
        <div className="flex justify-between gap-5 mb-5">
          <p className="font-semibold text-xl">Individual Tax Organizer</p>
        </div>

        {isLoading ? (
          <div className="flex justify-center flex-col mt-[20%]">
            <Spin size="large" />
            <p className="primary text-center mt-2">Loading...</p>
          </div>
        ) : (
          data?.map((item, index) => (
            <div className="table-radius-0 text-light mb-10">
              <p className="font-semibold text-xl text-primary mb-5">
                {`Section ${index + 1}:`} {item?.section_name}
              </p>
              <SkeletonTable
                columns={columns}
                data={item?.questions}
                isLoading={isLoading}
              />
            </div>
          ))
        )}
      </div>
      {/* View Files */}
      <ViewFilesModal
        isOpen={isFilesOpen}
        setIsOpen={setIsFilesOpen}
        question={selectedQuestion}
      />
    </div>
  );
}
